import { render } from "./App.vue?vue&type=template&id=b9e2dd88&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b9e2dd88&lang=scss"

import exportComponent from "/home/runner/work/ncore-external/ncore-external/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__